import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { removeKeysFromObject } from 'services/common';
import './style.css';

const { TextArea: AntTextArea } = Input;

class TextArea extends Component {
  getAttributes = () => {
    const unwantedProps = ['children', 'helperTxt', 'error', 'label'];
    return removeKeysFromObject(this.props, unwantedProps);
  };

  render() {
    const { children, error, helperTxt, className, label } = this.props;
    const selectClassName = error ? `${className} textarea-error` : className;
    const helperTxtClassName = error ? 'input-helper error' : 'input-helper';
    const labelClassName = error ? 'input-name error' : 'input-name';
    const attributes = this.getAttributes();

    return (
      <div className="input-group">
        {!!label && <label className={labelClassName}>{label}</label>}
        <AntTextArea {...attributes} className={selectClassName}>
          {children}
        </AntTextArea>
        {!!helperTxt && <div className={helperTxtClassName}>{helperTxt}</div>}
      </div>
    );
  }
}

TextArea.defaultProps = {
  children: [],
  className: '',
  error: '',
  helperTxt: '',
  label: '',
};

TextArea.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperTxt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  label: PropTypes.string,
};

export default TextArea;
